import React from "react";

export const Loader = () => {
  return <div className="loader__series">
    <ul className="loader">
      <li><div></div></li>
      <li><div></div></li>
      <li><div></div></li>
      <li><div></div></li>
      <li><div></div></li>
      <li><div></div></li>
      <li><div></div></li>
      <li><div></div></li>
      <li><div></div></li>
      <li><div></div></li>
      <li><div></div></li>
      <li><div></div></li>
      <li><div></div></li>
    </ul>
  </div>
};

export default Loader;


// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js